import {
  EAuditResultType,
} from '@/types/audit-result.ts';
import {
  TComponentValue,
} from '@/types/openapi-type.ts';

const sectionResult: Record<TComponentValue<'AuditResultType'>, string> = {
  [EAuditResultType.PASSED]: 'Im Band',
  [EAuditResultType.INCONCLUSIVE]: 'Unschlüssig',
  [EAuditResultType.FAILED]: 'Außerhalb des Bands',
};

export default {
  timeIn: 'Startzeit',
  timeOut: 'Endzeit',
  valueAtStart: 'Wert zu Beginn',
  valueRange: 'Wertebereich',
  mainTemp: 'Haupttemperatur',
  medianValue: 'Medianwert',
  timeInBand: 'Zeit in der Band',
  sectionResult,
};
